// \note proxied via package.json in dev builds
const API_URL = '/api'
const ADMIN_TEAM_ID = '0'
const BUILT_IN_ADMIN_WORKSPACE_ID = 'team:6a9c3kpzxpb0999v'
let gLoginStatus = 1
let gUserTeams = []

const apiQuery = (path, body) => {
  return window.fetch(API_URL + path, {
    cache: 'no-cache',
    method: 'POST',
    body: JSON.stringify(body),
    headers: {
      Authorization: 'Bearer ' + getIdToken(),
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
    .then(async response => {
      if (response.status >= 200 && response.status < 300) {
        // console.log('Success:', response.ok, response.status, response.body);
        return response.text()
          .then(body => {
            try {
              const json = JSON.parse(body)
              return json
            } catch (err) {
              console.log('ERROR IN BACKEND API CALL:')
              console.log(body)
              throw (body.toString() || 'EMPTY RETURN VALUE')
            }
          })
      } else {
        console.log('ERROR IN BACKEND API CALL2:')
        console.log(response)
        const json = await response.json()
        console.error('REQUEST FAILED:', JSON.stringify(json))
        if (json.errors) {
          console.log('ERRORS:')
          for (const err of json.errors) {
            console.log('  ' + JSON.stringify(err.message) + ' in ' + JSON.stringify(err.locations))
          }
        } else if (json.Error) {
          throw json.Error
        } else if (json.errorDescription) {
          throw new Error(json.errorDescription)
        }
        throw new Error('Request failed with code ' + response.status)
      }
    })
}

const getIdToken = () => {
  return window.localStorage.getItem('idToken')
}

const getGlueAwsVersionString = () => {
  return window.sessionStorage.getItem('versionString')
}

const setGlueAwsVersionString = versionString => {
  window.sessionStorage.setItem('versionString', versionString)
}

const getLoginStatus = () => {
  return gLoginStatus
}

const setLoginStatus = loginStatus => {
  gLoginStatus = loginStatus
}

// Get user's global role (either Administrator or non-administrator) to browser cache
const getUserGlobalRole = () => {
  return window.localStorage.getItem('userRole')
}

// Get user's global role (either Administrator or non-administrator) to browser cache
const getActiveTeam = () => {
  if (window.sessionStorage.getItem('activeTeam') && window.sessionStorage.getItem('activeTeam').length > 0 && window.sessionStorage.getItem('activeTeam') !== 'undefined') {
    return JSON.parse(window.sessionStorage.getItem('activeTeam'))
  } else {
    return null
  }
}

const getActiveTeamId = () => {
  if (window.location && window.location.pathname && window.location.pathname.startsWith('/embedded/')) {
    // For embedded pages, get active team from page URI
    let activeTeamId = window.location.pathname.split('/')[2]
    return activeTeamId
  } else if (window.sessionStorage.getItem('activeTeam') && window.sessionStorage.getItem('activeTeam') !== 'undefined' && window.sessionStorage.getItem('activeTeam').toString().length > 0) {
    return JSON.parse(window.sessionStorage.getItem('activeTeam')).value
  } else {
    return null
  }
}

const getActiveTeamName = () => {
  if (window.sessionStorage.getItem('activeTeam') && window.sessionStorage.getItem('activeTeam').length > 0 && window.sessionStorage.getItem('activeTeam') !== 'undefined') {
    let activeTeam = JSON.parse(window.sessionStorage.getItem('activeTeam'))
    if (activeTeam.text) {
      return activeTeam.text
    } else if (activeTeam.name) {
      return activeTeam.name
    } else if (activeTeam.options) {
      for (let i = 0; i < activeTeam.options.length; i++) {
        if (activeTeam.options[i].value === activeTeam.value) {
          return activeTeam.options[i].text
        }
      }
    }
  } else {
    return null
  }

  return null
}

// Get user's global role (either Administrator or non-administrator) to browser cache
const setActiveTeam = (e, workspace) => {
  window.sessionStorage.setItem('activeTeam', JSON.stringify(workspace))
}

// Get organization-specific role for user (e.g. user may be superuser in one organization but a regular member in another)
const getUserTeamSpecificRole = (teamId) => {
  let teamSpecificRole = 'none'
  if (window.localStorage.getItem('userRoleInOrganization') && teamId) {
    var teamRoleRawData = window.localStorage.getItem('userRoleInOrganization')
    let teamHashTable = JSON.parse(teamRoleRawData)
    if (teamHashTable[teamId]) {
      teamSpecificRole = teamHashTable[teamId]
    }
  }

  return teamSpecificRole
}

// Set user's global role (either Administrator or non-administrator) to browser cache
const setUserGlobalRole = userRole => {
  window.localStorage.setItem('userRole', userRole)
}

// Updates user's both global and organization specific roles to browser cache
const updateUserRolesToCache = organizations => {
  console.log('Updating user roles to cache')
  // Reset existing organization specific user role
  window.localStorage.setItem('userRoleInOrganization', null)
  if (window.localStorage.getItem('userRoleInOrganization')) {
    window.localStorage.removeItem('userRoleInOrganization')
  }

  if (organizations && organizations.length > 0) {
    gUserTeams = []
    let globalRole = getUserGlobalRole()
    for (var i = 0; i < organizations.length; i++) {
      let truncatedId = ''
      if (globalRole === 'administrator') {
        if (organizations[i] && organizations[i].teamId && organizations[i].teamId.indexOf(':') !== -1) {
          truncatedId = ' - ' + organizations[i].teamId.split(':')[1].substring(0, 5)
        } else if (organizations[i].teamId && organizations[i].teamId.length > 4) {
          truncatedId = organizations[i].teamId.substring(0, 5)
        }
      }
      gUserTeams.push({ text: organizations[i].name + truncatedId, value: organizations[i].teamId })
      // Set global user role (either administrator or member)
      if (i === 0) {
        let currentActiveTeam = getActiveTeam()
        if (!currentActiveTeam) {
          console.log('No active team found, setting team')
          setActiveTeam(null, { text: organizations[i].name, value: organizations[i].teamId })
        }
        if (organizations[i].selfRole && organizations[i].selfRole !== 'undefined') {
          setUserGlobalRole(organizations[i].selfRole)
        }
      } else if (getUserGlobalRole() !== 'administrator' && organizations[i].selfRole === 'administrator') {
        // Any other role is overwritten by admin role in any organization (administrator role is global
        // ==> being admin in any organization allows you to moderate other Glue organizations)
        setUserGlobalRole(organizations[i].selfRole)
      }

      // Apply organization specific roles if required (if user is global administrator, no organization specific role is needed)
      if (getUserGlobalRole() !== 'administrator' && organizations[i].selfRole === 'superuser') {
        // Only member-role is overwritten by superuser role for the specific organization superuser belongs
        // Superuser role is organization specific i.e. being superuser in one organization, does not permit
        // superuser rights to any other organization.
        if (!window.localStorage.getItem('userRoleInOrganization')) {
          // No organization level role data is found, initialize data
          let orgId = organizations[i].teamId
          let teamHashTable = {}
          teamHashTable[orgId] = 'superuser'
          window.localStorage.setItem('userRoleInOrganization', JSON.stringify(teamHashTable))
        } else {
          // Append organization level role data to hash table
          let teamSpecificUserRawData = window.localStorage.getItem('userRoleInOrganization')
          let teamHashTable = JSON.parse(teamSpecificUserRawData)
          let orgId = organizations[i].teamId
          teamHashTable[orgId] = 'superuser'
          window.localStorage.setItem('userRoleInOrganization', JSON.stringify(teamHashTable))
        }
      } else {
        if (!window.localStorage.getItem('userRoleInOrganization')) {
          // No organization level role data is found, initialize data
          let orgId = organizations[i].teamId
          let teamHashTable = {}
          teamHashTable[orgId] = organizations[i].selfRole
          window.localStorage.setItem('userRoleInOrganization', JSON.stringify(teamHashTable))
        } else {
          // Append organization level role data to hash table
          let teamSpecificUserRawData = window.localStorage.getItem('userRoleInOrganization')
          let teamHashTable = JSON.parse(teamSpecificUserRawData)
          let orgId = organizations[i].teamId
          teamHashTable[orgId] = organizations[i].selfRole
          window.localStorage.setItem('userRoleInOrganization', JSON.stringify(teamHashTable))
        }
      }
    }

    console.log(getUserGlobalRole())
    if (getUserGlobalRole() === 'administrator') {
      gUserTeams.unshift({ text: 'Admin Workspace', value: ADMIN_TEAM_ID })
      if (!getActiveTeam()) {
        setActiveTeam({ text: 'Admin Workspace', value: ADMIN_TEAM_ID })
      }
    }
  }
}

export {
  apiQuery,
  getIdToken,
  getLoginStatus,
  setLoginStatus,
  getUserGlobalRole,
  setUserGlobalRole,
  updateUserRolesToCache,
  getUserTeamSpecificRole,
  gUserTeams,
  getActiveTeam,
  setActiveTeam,
  ADMIN_TEAM_ID,
  getActiveTeamName,
  getGlueAwsVersionString,
  setGlueAwsVersionString,
  BUILT_IN_ADMIN_WORKSPACE_ID,
  API_URL,
  getActiveTeamId
}
